var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "warning-card",
    [
      _c(
        "notice",
        {
          attrs: {
            icon: "/static/proof-of-payment.svg",
            title: "Quase lá... Agora é só confirmar o pedido!",
            subtitle:
              "Você contratou a limpeza com menos de 48h de antecedência e selecionou boleto como forma de pagamento. Envie o comprovante de pagamento para confirmá-la."
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "btn bg-pink-outline mt-10",
              on: { click: _vm.openSupport }
            },
            [_vm._v("enviar o comprovante")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7fcba90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7fcba90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Warnings/ProofOfPayment.vue
// module id = null
// module chunks = 